<template>
    <div class="pagination-row">
        <button
            :class="[
                'pagination-button',
                currentPage == currentPage + 1 ? 'active' : ''
            ]"
            :disabled="currentPage <= 1"
            @click="goBack(currentPage)"
        >
        <img class="chevron" src="https://assets.rhinorack.com/Images/Others/chevron-l.png" alt="cheron-icon">
        </button>

        <span v-for="(item, index) in pageRange" :key="index">
            <button
                :class="[
                    'pagination-button',
                    currentPage == item ? 'active' : ''
                ]"
                @click="updatePage(item)"
            >
                {{item}}
            </button>
        </span>

        <button
            :class="[
                'pagination-button',
                currentPage == pageRange ? 'active' : ''
            ]"
            :disabled="currentPage >= finalPage"
            @click="nextPage(currentPage)"
        >
            <img class="chevron" src="https://assets.rhinorack.com/Images/Others/chevron-r.png" alt="cheron-icon">
        </button>
    </div>
</template>

<script>
export default {
    name: "modal-pagination",
    props: {
        pageReset: Boolean,
        pageRange: Array,
        finalPage: null,
        currentPageShare: {
            default: 1,
        },
    },
    data() {
        return {
            currentPage: 1,
            previousPage: null,
            pageNext: null,
            dotString: false,
        };
    },
    watch: {
        currentPageShare(currentPage) {
            if(currentPage !== this.currentPage) {
                this.currentPage = currentPage;
            }
        }
    },
    methods: {
        updatePage(item) {
            if (item == '...') {
                console.log("not a number");
            } else if(item != '...') {
                this.currentPage = item;
                this.$emit("changePage", this.currentPage);
            }
        },
        goBack(currentPage) {
            if (currentPage != '...') {
                this.currentPage = currentPage - 1;
                this.$emit("changePage", this.currentPage);
            }
        },
        nextPage(currentPage) {
            if (currentPage != '...') {
                this.currentPage = currentPage + 1;
                this.$emit("changePage", this.currentPage);
            }
        },
        submit() {
            this.$emit("pagination");
        },
    },
    updated() {
        if (this.pageReset == true) {
            this.currentPage = 1;
        }
    },
};
</script>

<style lang="scss" scoped>
.pagination-row {
    display: flex;
    justify-content: space-evenly;
    width: max-content;
    padding: 7px 10px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: white;
}

.pagination-button {
    margin: 0 1px;
    padding: 5px 15px;
    border: none;
    font-size: 1rem;
    outline: none;
    background: transparent;
    font-family: "trim-medium";

    &.active {
        color: white;
        background-color: #015cb8;
    }

    &:disabled {
        cursor: auto;
        background-color: #e3e3e3;
        color: black;
    }
}

.chevron {
    height: 12px;
}

.pagination {
    border: 1px solid rgba(0, 0, 0, 0.1);
    height: 50px;
    padding: 5px;
    background-color: white;
    list-style-type: none;
}

.pagination-item {
    display: inline-block;
}

.active {
    background-color: #015cb8;
}
</style>
